export default __webpack_public_path__ + "static/team-image-2-4cb7091ace2552e98be20cacb20d8a80.png";